export default __webpack_public_path__ + "static/universal-a52504fc2f1c7467e95132157aa92081.png";